import { InternalPage } from 'theSource/components';
import { ProfilePicture } from 'enrollment/components/ProfilePicture/ProfilePicture';

export const ProfileEdit = () => {
  return (
    <InternalPage
      testId="dashboard-container"
      id="enrollment-dashboard-container"
      blockClasses="mt-lg-2_5 mt-md-5 px-4 pt-3 pb-4 pt-md-3_5 p-md-0 pt-lg-0"
    >
      <ProfilePicture />
    </InternalPage>
  );
};
